<template>
  <div class="tableContainer">
    <table class="contentListing">
      <thead class="doubleHeader">
        <tr>
          <th v-if="enableExpansion" />
          <th data-automation="activity-header-action">
            Action
          </th>
          <th data-automation="activity-header-published">
            {{ dateHeader }}
          </th>
          <th data-automation="activity-header-duration">
            Duration ≈
          </th>
          <th data-automation="activity-header-status">
            Status
          </th>
          <th
            v-if="!python"
            data-automation="activity-header-packagaeversions"
            :colspan="colSpan"
            class="spanner"
          >
            Package Versions
          </th>
          <th
            v-if="python"
            data-automation="activity-header-packages"
            colspan="3"
            style="text-align: center; border-right: solid; border-left: solid; border-color: #e8e8e8; border-width: thin;"
          >
            Packages
          </th>
          <th
            data-automation="activity-header-id"
            style="text-align: center"
          >
            Id
          </th>
        </tr>
        <tr>
          <th
            v-if="!python"
            colspan="5"
          />
          <th
            v-else
            colspan="4"
          />
          <th
            v-if="python"
            data-automation="activity-header-added"
            style="text-align: center; border-left: solid; border-color: #e8e8e8; border-width: thin;"
          >
            Added
          </th>
          <th
            v-else
            data-automation="activity-header-added"
          >
            Added
          </th>
          <th
            v-if="python"
            data-automation="activity-header-archived"
          >
            Updated
          </th>
          <th
            v-if="!python"
            data-automation="activity-header-archived"
          >
            Archived
          </th>
          <th
            v-if="!python"
            data-automation="activity-header-deleted"
          >
            Deleted
          </th>
          <th
            v-if="python"
            data-automation="activity-header-deleted"
            style="text-align: center; border-right: solid; border-color: #e8e8e8; border-width: thin"
          >
            Deleted
          </th>
          <th />
        </tr>
      </thead>
      <TransactionListItem
        v-for="t in transactions"
        :key="t.id"
        :transaction-item="t"
        :now="now"
        :enable-expansion="enableExpansion"
        :python="python"
      />
    </table>
  </div>
</template>

<script>

import { mapGetters, mapState } from 'vuex'
import TransactionListItem from './TransactionListItem'

export default {
  name: 'TransactionsList',
  components: {
    TransactionListItem,
  },
  props: {
    transactions: {
      type: Array,
      required: true,
    },
    dateHeader: {
      type: String,
      default: 'Published',
    },
    enableExpansion: {
      type: Boolean,
      required: false,
      default: true,
    },
    python: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: function () {
    return {
      now: new Date(),
      timerId: null,
    }
  },
  computed: {
    ...mapGetters(['getWindow']),
    ...mapState({
      currentRepoSources: state => state.repos.currentRepoSources,
      currentRepoSourceType: state => state.repos.currentRepoSourceType,
      colSpan: function () {
        if (this.python) {
          return 4
        }
        return 3
      },
    }),
  },
  mounted: function () {
    this.timerId = this.getWindow.setInterval(this.updateNow, 60000) // update once a minute
  },
  beforeDestroy: function () {
    if (this.timerId) {
      this.getWindow.clearInterval(this.timerId)
    }
  },
  methods: {
    updateNow: function () {
      this.now = new Date()
    },
  },
}

</script>
